import { render, staticRenderFns } from "./advanced-tables.vue?vue&type=template&id=50df8896"
import script from "./advanced-tables.vue?vue&type=script&lang=js"
export * from "./advanced-tables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports